<template>
  <!-- <div class="middle-center">
    <global-spinner :animation-duration="1500" :size="50" color="#2196f3" />
  </div> -->
  <div class="loader-wrapper" style="margin-top:unset">
    <div class="loader" style="margin-top:unset">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
</template>

<script>
export default {}
</script>

<style scoped>
.middle-center {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
